<!-- @veltra/icons generated sha256:f707afa83a08f314 gen:8 source:src/svg/normal/view.svg -->
<script setup lang="ts">
defineOptions({ name: 'UView' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M8.005 12.5c-2.903 0-5.544-1.63-6.888-4.27a.5.5 0 0 1 0-.46C2.46 5.14 5.102 3.5 8.005 3.5c2.893 0 5.534 1.64 6.878 4.27a.5.5 0 0 1 0 .46c-1.344 2.64-3.985 4.27-6.878 4.27M2.399 8.474C3.655 10.362 5.734 11.5 8.005 11.5c2.262 0 4.349-1.138 5.605-3.026a.85.85 0 0 0-.002-.948C12.345 5.638 10.267 4.5 8.005 4.5c-2.271 0-4.35 1.138-5.606 3.026a.85.85 0 0 0 0 .948M8 10.88a2.88 2.88 0 1 0 0-5.76 2.88 2.88 0 0 0 0 5.76m0-4.76a1.88 1.88 0 1 1 0 3.76 1.88 1.88 0 0 1 0-3.76"
    />
  </svg>
</template>
